import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesGrid from './components/ServicesGrid';
import TurnkeySection from './components/TurnkeySection';
import TestimonialSection from './components/TestimonialSection';
import WhoWeServeSection from './components/WhoWeServeSection';
import WhyMedilineSection from './components/WhyMedilineSection';
import ContactCTA from './components/ContactCTA';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation transparent />
      <main>
        <HeroSection />
        <ServicesGrid />
        <TurnkeySection />
        <TestimonialSection />
        <WhoWeServeSection />
        <WhyMedilineSection />
        <ContactCTA />
      </main>
      <Footer />
    </div>
  );
}
